// extracted by mini-css-extract-plugin
module.exports = {"pastAnalysis":"PastEventAnalysis_pastAnalysis__2vaWc","noEvent":"PastEventAnalysis_noEvent__19XE_"};